
const siteConfig={
    name:"Satyam Jha",
    title:"Web and Android Native Developer",
    description:"I Build Web App and Android Apps",
    email:"satyamjhastudy@gmail.com",
    resume:"",
    social:{
        github:"https://github.com/Satyamjha76",
        linkedin:"https://www.linkedin.com/in/satyamjha-in/",
        twitter:"https://x.com/satyamjha_in",
        leetcode:"https://leetcode.com/u/satyamjha_in/",
        medium:"https://medium.com/@satyamjha_in",
        naukri:"",
        instagram:"https://www.instagram.com/satyamjha_in",
        playstore:"https://play.google.com/store/apps/dev?id=5642918511460189797",

    },

};
export default siteConfig;